import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css'],
  standalone: false
})
export class ErrorComponent {

  errorMessage = 'Unexpected Error';
  constructor(private router:Router) {
    const navigation = this.router.getCurrentNavigation();
    if(navigation?.extras?.state) {
      this.errorMessage = navigation.extras.state.data || this.errorMessage;
    }
  }
/*
  ngOnInit(): void {
  }
*/
  refresh(){
    this.router.navigateByUrl('/home');
  }

}
